import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { DatePipe } from '@angular/common';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/common";
var GLOBALService = /** @class */ (function () {
    function GLOBALService(http, datePipe) {
        this.http = http;
        this.datePipe = datePipe;
        this.iduser = localStorage.getItem("userId");
        this.fecha_hoy = new Date;
        this.horahoy = new Date;
    }
    GLOBALService.prototype.saludo = function () {
        this.persona = "rial";
        console.log("saludo a: " + this.persona);
        return this.persona;
    };
    GLOBALService.prototype.horario = function () {
        this.hora = (this.horahoy.getHours() + ":" + this.horahoy.getMinutes());
        return this.hora;
    };
    GLOBALService.prototype.historicalTo = function (accion, catego) {
        var _this = this;
        this.fecha_hoy = new Date;
        this.hoy = this.datePipe.transform(this.fecha_hoy, "yyyy-MM-dd");
        //http://localhost:1337/api/historico/add?iduser=35363906&observ=mentis&fecha=2019-01-09&cate=NO-DEFINE 
        this.http.get(environment.backendUrl + "/api/historico/add?iduser=" + this.iduser + "&observ=" + accion + "&fecha=" + this.hoy + "&cate=" + catego)
            .subscribe(function (data) {
            _this.result = JSON.stringify(data["affectedRows"]);
            if (_this.result > 0) {
                console.log("GLOBAL-> **Accion añadida: user: " + _this.iduser + ", accion: " + accion + " fecha: " + _this.hoy + " a las " + _this.horario() + "**");
            }
            else {
                console.log("**salio mal**");
                return "**GLOBAL-> **salio mal**";
                //return res="fallo"
            }
        });
    };
    GLOBALService.ngInjectableDef = i0.defineInjectable({ factory: function GLOBALService_Factory() { return new GLOBALService(i0.inject(i1.HttpClient), i0.inject(i2.DatePipe)); }, token: GLOBALService, providedIn: "root" });
    return GLOBALService;
}());
export { GLOBALService };
